import { Navigate } from "react-router-dom";
import { Construction } from "lucide-react";
import { useDemo } from "@/store/DemoStore";
import { Card, Empty, PageHeader } from "@/components/common";

export function AdminOnly({ children }) {
  const { isAdmin } = useDemo();
  return isAdmin ? children : <Navigate to="/agent" replace />;
}

export function AdminPlaceholder({ title, subtitle, testId }) {
  return (
    <div className="max-w-5xl" data-testid={testId}>
      <PageHeader title={title} subtitle={subtitle} />
      <Card><Empty icon={Construction} title="Coming soon" text="This admin section is set up and ready to build." /></Card>
    </div>
  );
}
